import { render, staticRenderFns } from "./power-dialer-session-setting.vue?vue&type=template&id=2b6bc920"
import script from "./power-dialer-session-setting.vue?vue&type=script&lang=js"
export * from "./power-dialer-session-setting.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports